/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import Vue from 'vue';

import {
  FETCH_USER,
} from '../actions.type';

import {
  SET_USER_REQUEST,
  SET_USER,
} from '../mutations.type';

const state = {
  request: {},
  user: {},
};

const actions = {
  async [FETCH_USER]({ commit }) {
    try {
      const { data: { user } } = await Vue.axios.get('auth/user', {
        'axios-retry': {
          retries: 5,
          beforeTry: () => {
            commit(SET_USER_REQUEST, {
              isLoading: true,
              isError: false,
            });
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_USER_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime,
            });
          },
        },
      });
      commit(SET_USER_REQUEST, {
        isSuccess: true,
      });
      commit(SET_USER, user);
    } catch (e) {
      commit(SET_USER_REQUEST, {
        isFatalError: true,
      });
    }
  },
};

const mutations = {
  [SET_USER_REQUEST](state, request) {
    state.request = request;
  },
  [SET_USER](state, user) {
    state.user = user;
  },
};

export default {
  state,
  mutations,
  actions,
};
